import { createContext, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';

export type FormMode = 'read' | 'edit' | 'create';

export type FormContextValue<TFormValues extends object> = {
  mode: FormMode;
  setMode: (mode: FormMode) => void;
  onCancel?: () => void;
  isSaving?: boolean;
  isDeleting?: boolean;
  isRestoring?: boolean;
  onDelete?: () => void;
  onRestore?: () => void;
  error?: unknown;
  editPermissions?: number[];
  deletePermissions?: number[];
  restorePermissions?: number[];
  createPermissions?: number[];
  formMethods: UseFormReturn<TFormValues>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormContext = createContext<FormContextValue<any> | undefined>(undefined);

export const useFormContext = <TFormValues extends object>() => {
  const context = useContext(FormContext);

  if (context === undefined) {
    throw new Error('useFormContext must be used within a FormProvider');
  }

  return context as unknown as FormContextValue<TFormValues>;
};
